<div class="wrapper">
	<div
		class="custom-dropzone"
		kendoUploadDropZone="myZone">
		<kendo-svg-icon
			class="custom-theme"
			[icon]="uploadIcon"
			size="xlarge"></kendo-svg-icon>

		<p class="custom-hint">
			Drag and drop files here to upload.<br />
			(PNG, JPEG, or BMP)
		</p>
	</div>
	<kendo-fileselect
		zoneId="myZone"
		(select)="onSelect($event)"
		[showFileList]="false"
		[multiple]="false"
		[restrictions]="fileRestrictions">
	</kendo-fileselect>
</div>
<div class="file-viewer-container">
	<div class="image-list">
		<div
			*ngFor="let image of images; let i = index"
			class="image-item">
			<img
				[src]="image.url"
				alt="Image"
				(click)="viewImage(image)" />
			<button
				kendoButton
				class="doc-download"
				(click)="removeImage(i)"
				[svgIcon]="deleteIcon"></button>
		</div>
	</div>

	<kendo-dialog
		*ngIf="selectedImage"
		(close)="closeDialog()">
		<kendo-dialog-titlebar> Image Viewer </kendo-dialog-titlebar>
		<img
			[src]="selectedImage.url"
			alt="Selected Image"
			class="full-image" />
	</kendo-dialog>
</div>
